import React from "react";
import "./index.scss";
import {bool, func} from "prop-types";

export const RadioSelection = (props) => {
    const {isSelected, children, onSelection, disabled = false} = props;
    return <div className={`radio ${isSelected ? "selected" : ""} ${disabled ? "disabled" : ""}`} onClick={onSelection}>
        {children}
    </div>
}
RadioSelection.propTypes = {
    isSelected: bool.isRequired,
    onSelection: func.isRequired,
    disabled: bool
}